import * as yup from 'yup'

export const schema = yup.object({
  name: yup.string().required('Name is required'),
  domain: yup.object().shape({
    name: yup.string().required('Domain name is required'),
    enableCustomDomain: yup.boolean().required('Enable custom domain is required'),
  }),
  description: yup.string().required('Description is required'),
  opensearch: yup.object().shape({
    instanceType: yup.string().required('Instance type is required'),
    dataNodes: yup
      .number()
      .nullable()
      .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null || originalValue === undefined)
          return null
        return value
      })
      .min(0, "Can't be negative")
      .required('Data nodes is required'),
    volumeSize: yup
      .number()
      .nullable()
      .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null || originalValue === undefined)
          return null
        return value
      })
      .min(0, "Can't be negative")
      .required('Volume size is required'),
  }),
  events: yup.object().shape({
    source: yup
      .string()
      .test('is-valid-source', 'Must be a valid source', (value, context) => {
        if (!value) return context.createError({ message: 'Source is required' })

        try {
          const parsedValue = JSON.parse(value)

          return yup.array().of(yup.string()).isValidSync(parsedValue)
        } catch (error) {
          return false
        }
      })
      .required('Source is required'),
    detailType: yup
      .string()
      .test('is-valid-detail-type', 'Must be a valid detail type', (value, context) => {
        if (!value) return context.createError({ message: 'Detail type is required' })

        try {
          const parsedValue = JSON.parse(value)

          return yup.array().of(yup.string()).isValidSync(parsedValue)
        } catch (error) {
          return false
        }
      })
      .required('Detail type is required'),
    externalAccountId: yup
      .string()
      .test(
        'is-valid-external-account-id',
        'Must be a valid external account ID',
        (value, context) => {
          if (!value) return context.createError({ message: 'External account ID is required' })

          try {
            const parsedValue = JSON.parse(value)

            return externalAccountIdSchema.isValidSync(parsedValue)
          } catch (error) {
            return false
          }
        },
      )
      .required('External account ID is required'),
  }),
})

const externalAccountIdSchema = yup.array().of(
  yup.object().shape({
    id: yup.string().required('ID is required'),
    description: yup.string().required('Description is required'),
  }),
)

const filterPolicyJsonSchema = yup.object({
  event_type: yup.string().test('is-valid-event-type', 'Must be an array of string', (value) => {
    if (!value) return true
    try {
      const parsedValue = JSON.parse(value)
      if (!Array.isArray(parsedValue)) return false
      if (parsedValue.some((value) => typeof value !== 'string')) return false
      return true
    } catch (error) {
      return false
    }
  }),
})

const pubSubSchema = yup.object({
  lambdaSrcKey: yup.string(),
  filterPolicyJson: filterPolicyJsonSchema,
})

const cognitoCustomAttributeSchema = yup.object({
  name: yup.string().required('Custom attribute name is required'),
  mutable: yup.boolean().required('Mutable is required'),
  minLen: yup.number().optional(),
  maxLen: yup.number().optional(),
})

const cognitoRoleSchema = yup.object({
  roleName: yup.string().required('Role name is required'),
  description: yup.string().optional(),
})

const cognitoConfigSchema = yup.object({
  customAttributes: yup.array().of(cognitoCustomAttributeSchema).optional().default([]),
  defaultAttributes: yup
    .array()
    .of(yup.string().required('Default attribute must be a string'))
    .optional()
    .default([]),
  roles: yup.array().of(cognitoRoleSchema).optional().default([]),
})

export const bulkSchema = yup.object({
  pubsubs: yup.object().shape({
    order: pubSubSchema,
    notification: pubSubSchema,
    app: pubSubSchema,
  }),
  cognitoConfig: yup
    .string()
    .test('is-valid-cognito-config', 'Must be a valid cognito configuration', (value) => {
      if (!value) return true
      try {
        const parsedValue = JSON.parse(value)
        return cognitoConfigSchema.isValidSync(parsedValue)
      } catch (error) {
        return false
      }
    }),
})
